const KEY = 'lang';

export function readLang() {
  return localStorage.getItem(KEY) || 'en';
}

export function writeLang(lang) {
  localStorage.setItem(KEY, lang);
}

export function removeLang() {
  localStorage.removeItem(KEY);
}
